<template>
  <div
    class="tw-mb-1"
    data-walkthrough-id="recently-used-queries"
    data-testid="recently-used-queries"
  >
    <div
      class="tw-pt-4 tw-px-4 sf-below-1"
      :class="
        inFloatingSidepane ? 'tw-text-sm tw-font-medium' : 'sf-title sf-font-l'
      "
    >
      {{ I18n.t('companies_overview.segments_new.recently_used') }}
    </div>

    <SegmentList
      :segments="recentSegments"
      :loading="loading"
      :test-id="'recent-queries-list'"
      @item-click="selectSegment"
    >
      <template #static-item>
        <SegmentListItem
          :segment="allClientsFakeSegment"
          :loading="loading"
          @item-click="selectAllClients"
        >
          <template #tooltip>
            <i
              v-tooltip.placementBottom="allClientsTooltip"
              class="fa fa-info-circle tw-pl-1 tw-text-sf-gray-light"
            ></i>
          </template>
        </SegmentListItem>
      </template>
    </SegmentList>

    <div
      v-if="recommendedSegments.length > 0"
      class="tw-px-4 tw-pt-4 sf-below-1"
      :class="
        inFloatingSidepane ? 'tw-text-sm tw-font-medium' : 'sf-title sf-font-l'
      "
      data-walkthrough-id="recommended-segments"
    >
      {{ I18n.t('companies_overview.segments_new.recommended') }}
    </div>
    <SegmentList
      :segments="recommendedSegments"
      :test-id="'recommended-queries-list'"
      :loading="loading"
      @item-click="selectSegment"
    ></SegmentList>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapState as mapPiniaState, mapActions as mapPiniaActions } from 'pinia'
import { useCompaniesStore } from '@app/insights/store/companies'
import { useSegmentsStore } from '@app/insights/store/segments'
import { useInsightsRootStore } from '@app/insights/store/insights-root'
import SegmentListItem from './segment-list-item.vue'
import SegmentList from './segment-list.vue'
import sharedSegment from '../mixins/shared-segment'
import { INSIGHTS_LAYOUT_CONTEXT_KEY } from '@app/insights/composables/use-insights-layout-context'

export default {
  components: {
    SegmentListItem,
    SegmentList,
  },
  mixins: [sharedSegment],

  inject: {
    insightsLayoutContext: {
      from: INSIGHTS_LAYOUT_CONTEXT_KEY,
      default: () => ({ inFloatingSidepane: false }),
    },
  },

  computed: {
    inFloatingSidepane() {
      return this.insightsLayoutContext.inFloatingSidepane
    },
    ...mapPiniaState(useCompaniesStore, [
      'companiesFullyLoaded',
      'companiesFullyLoadedAt',
      'allCompaniesProcessed',
      'getError',
    ]),
    ...mapPiniaState(useSegmentsStore, ['segments', 'segment']),
    ...mapPiniaState(useInsightsRootStore, {
      recentSegmentsIds: 'recentSegments',
    }),
    allClientsTooltip() {
      return I18n.t('companies_overview.segments_new.show_all_files')
    },
    loading() {
      return !this.allCompaniesProcessed && !this.getError
    },
    recentSegments() {
      const r = this.recentSegmentsIds
        .map((id) =>
          this.segments.find((segment) => segment.id === parseInt(id))
        )
        .filter((segment) => segment && !segment.partner_segment_id)

      return _.uniq(r).slice(0, 5)
    },
    recommendedSegments() {
      return this.segments.filter((segment) => segment.recommended)
    },
  },

  methods: {
    ...mapPiniaActions(useSegmentsStore, [
      'loadSegment',
      'unselectSegment',
      'addToRecent',
    ]),

    selectSegment(segment) {
      if (!this.segment || this.segment.id !== segment.id) {
        if (!this.recentSegments.includes(segment) && !segment.recommended) {
          this.addToRecent(segment)
        }
        this.loadSegment(segment)
      }
    },
  },
}
</script>

<style scoped>
.sf-title {
  color: #262626;
  margin-bottom: 4px;
}
</style>
